const About = ({about}) => {
    return (
        <aside className='about mb-4 col-3 bg-body-tertiary rounded-3'>
            <div className=" p-3 text-start">
                <h3>
                    About Me:
                </h3>
                {about}

                <div className="py-3 email">
                    <span>
                    Email:     
                    </span>
                    
                     <u>ds.shoaibkhalid@gmail.com</u>
                </div>
            </div>
        </aside>
    )
}

export default About;